module.exports = __webpack_public_path__ + "media/images/icons/larr_white-a0d4d4851026d7a2e2652579fffa9646.svg";